import "blocks/PrePacksWeb/ui/PrePacksWeb.less";
import * as React from "react";
import { observer } from "mobx-react";
import { FilterWeb, PrePacksBase } from "../../../components";
import { FiltersWeb } from "../components";
export class PrePacksWebComponent extends PrePacksBase {
    constructor(props) {
        super(props);
    }
    getOverlay() {
        return React.createElement("div", { className: "rj-prepacksboard-overlay", "data-testid": "wrapper-prepacks-overlay" });
    }
    buildFilters() {
        return React.createElement(FiltersWeb, { filters: this.props.dataProvider.filters, filterComponent: this.buildFilter, tabsAnimation: this.props.dataProvider.config.tabsAnimation });
    }
    buildFilter(props) {
        return React.createElement(FilterWeb, Object.assign({}, props, { key: `filter-key-${props.id}` }));
    }
}
export const PrePacksWeb = observer(PrePacksWebComponent);
//# sourceMappingURL=PrePacksWeb.js.map